import Tag from '/react4xp/components/prototype/Tag'

import type { ReferenceHeroProps } from './types'

export default function ReferenceHero({
	title,
	customerLabel = 'Kunde:',
	customer,
	deliveryLabel = 'Leveranse:',
	delivery,
	tags = [],
	image,
	ingress,
}: ReferenceHeroProps) {
	const hasInfo = Boolean(customer) || Boolean(delivery) || tags.length > 0

	return (
		<section className="mb-16">
			<div className="bg-black-950 py-12 xl:py-16">
				<div className="container flex flex-col gap-6 xl:flex-row xl:justify-between xl:items-start xl:gap-8">
					<h1 className="h1 text-pure-white">{title}</h1>

					{hasInfo && (
						<div className="flex flex-col gap-4">
							{customer && (
								<p className="body">
									<span className="text-brand-500">{customerLabel}</span>{' '}
									<span className="text-pure-white">{customer}</span>
								</p>
							)}

							{delivery && (
								<p className="body">
									<span className="text-brand-500">{deliveryLabel}</span>{' '}
									<span className="text-pure-white">{delivery}</span>
								</p>
							)}

							{tags.length > 0 && (
								<div className="flex flex-wrap gap-4">
									{tags.map((tag, i) => (
										<Tag key={i} label={tag.label} href={tag.href} isExternal={tag.isExternal} />
									))}
								</div>
							)}
						</div>
					)}
				</div>
			</div>

			{image && (
				<div className="relative">
					<div className="absolute inset-x-0 top-0 h-[70%] w-full bg-black-950" aria-hidden="true" />

					<div className="container relative">
						<figure className="aspect-5/3 w-full max-w-full overflow-hidden rounded-xs">
							<img src={image.src} alt={image.alt ?? ''} className="object-cover w-full h-full" />
						</figure>
					</div>
				</div>
			)}

			{ingress && (
				<div className="container mt-16">
					<p className="body-xl text-black-950 w-full xl:max-w-200 xl:mx-auto">{ingress}</p>
				</div>
			)}
		</section>
	)
}
